import { useTranslation } from "react-i18next";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import ThanksCard from "./ThanksCard";
import "./FinalResponse.scss";

export interface Props {
  rtl: boolean;
}

function Thanks({ rtl }: Props) {
  const { t } = useTranslation();
  const dir = rtl ? "right" : "left";
  let thanksCardData: any = sessionStorage.getItem("productInformationData");
  thanksCardData = JSON.parse(thanksCardData);

  return (
    <div className="container">
      <div className="row">
        {/* <div className="col-sm-12 thanks-container">
          <Typography className="thanks-title" rtl={rtl}>
            {t("Your_Order")}
          </Typography>
          <div className={`thanks-cards-${dir}`}>
            {thanksCardData.length > 0 &&
              thanksCardData.map(
                (OrderDetailsProductThanks: any, index: any) => (
                  <ThanksCard
                    key={OrderDetailsProductThanks.productInformation.packageName.value + index}
                    rtl={rtl}
                    orderDetailsCard={OrderDetailsProductThanks}
                  />
                )
              )}
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default Thanks;
